import { LoadingArea } from "@/components/elements/Loading/Loading";
import { Box, Typography } from "@mui/material";
import { Modal } from "@/components/elements/Modal";
import { DropZone, TDropZoneProps } from "@/components/elements/DropZone";
import { FCC } from "@/types/common";
import { ReactNode, useState } from "react";
import { TExtendFile } from "@/types/file";
import { MAX_SIZE_ERROR, TFileUploadFor } from "@/constants/file";
import { divider } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { toast } from "@/utils/toast";

type TUploadPopupProps = {
  title?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onDropFiles?: (files: TExtendFile[]) => Promise<boolean>; //isError
  onFinishUpload: (files: TExtendFile[]) => void;
  onCancel?: () => void;
  isLoading?: boolean;
  uploadFor: TFileUploadFor;
} & Omit<TDropZoneProps, "enableFileList">;

export const UploadFile: FCC<TUploadPopupProps> = ({
  children,
  title,
  isOpen,
  onClose,
  onDropFiles,
  rules = {},
  isLoading = false,
  onFinishUpload,
  ...rest
}) => {
  const [, setDropFiles] = useState<TExtendFile[]>([]);

  const handleChangeFiles = async (value: TExtendFile | TExtendFile[] | null) => {
    let files = [value ?? []].flat();
    if (!files.length) return;
    let maxSizeError = false;
    files = [files[0]];
    // console.log(files);
    files.forEach((file) => {
      const { maxSize } = rules;
      const { size } = file;
      if (maxSize && size > maxSize) {
        maxSizeError = true;
        toast.error(MAX_SIZE_ERROR(maxSize));
        onClose();
        return;
      }
    });
    if (maxSizeError) return;
    onFinishUpload(files);
    const isError = await onDropFiles?.(files);
    if (isError) return;
    setDropFiles(files);
    onClose();
  };
  return (
    <>
      <Modal title={title} isOpen={isOpen} onClose={onClose} enableFooter={false} enableCloseIcon={!isLoading}>
        <Box mt={2} p={3} border="1px solid" borderColor={divider.high} borderRadius={rounded.sm}>
          {isLoading ? (
            <LoadingArea />
          ) : (
            <DropZone {...rest} enableFileList={false} onChange={handleChangeFiles} nonControl rules={rules}>
              {children ?? <Typography variant="body14" whiteSpace="pre-wrap" textAlign="center">{`ファイルを\nドラッグ&ドロップ`}</Typography>}
            </DropZone>
          )}
        </Box>
      </Modal>
    </>
  );
};
